import * as stylex from '@stylexjs/stylex';
import { useCanGoBack, useNavigate, useRouter } from '@tanstack/react-router';

import { ArrowLeftStrokeIcon, Button, Heading, Text } from '@/libs/serenity-ui';

export function NotFoundState () {
  const canGoBack = useCanGoBack();
  const router = useRouter();
  const navigate = useNavigate();

  return (
    <div {...stylex.props(styles.container)}>
      <div {...stylex.props(styles.contentContainer)}>
        <Heading color="placeholder" level={1} size={52} style={styles.heading}>Page not found</Heading>
        <Button isRounded size={40} onPress={() => (canGoBack ? router.history.back() : navigate({ to: '/' }))}>
          {canGoBack ?
            <>
              <ArrowLeftStrokeIcon />
              <Text>Back</Text>
            </> :
            'Home'}
        </Button>
      </div>
    </div>
  );
}

const styles = stylex.create({
  container: {
    height: '100%',
    width: '100%',
  },
  contentContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    justifyContent: 'center',
    paddingTop: 160,
    width: '100%',
  },
  heading: {
    textAlign: 'center',
  },
});
